import { path } from 'ramda'
import { getStatusFor } from '../../utils/curriculum-helper'
import { isAssociate, isStudent, getProgramTypeCode } from '../../utils/index'

export const visibilityFilter = link => !link.hidden

export const currentProgram = user => link => {
  const status = (isStudent(user) || isAssociate(user))
    ? getStatusFor(getProgramTypeCode(user), path(['education', 'currentLevel'], user))
    : ''
  return link.program ? status === link.program[0] : true
}
